import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { ISetting } from '@/types/set.d';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '配置 - 模态框 -',
    component: 'set/components/bModal',
  };

  public form: any = {
    sort: 0,
    classHour: 0,
    structure: 'INFORMAL',
  }

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    title: [
      { required: true, message: '名称不能为空' },
    ],
    classHour: [
      { required: true, message: '课时不能为空' },
    ],
    structure: [
      { required: true, message: '课程体系不能为空' },
    ],
    sort: [
      { required: true, message: '排序不能为空' },
    ],
    visible: [
      { required: true, message: '课时不能为空' },
    ],
    iconPath: [
      { required: true, message: '课时不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
